import React from "react";
var __jsx = React.createElement;
import { FormProvider as RHFForm } from 'react-hook-form';

// ----------------------------------------------------------------------

export function Form(_ref) {
  var children = _ref.children,
    onSubmit = _ref.onSubmit,
    methods = _ref.methods;
  return /*#__PURE__*/React.createElement(RHFForm, methods, /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit,
    noValidate: true,
    autoComplete: "off"
  }, children));
}